import * as common from './common'
import * as serviceGroups from './service-groups'
import * as services from './services'
import * as cases from './case'
import * as caseServiceLog from './case-service-log'
import * as invoices from './invoices'
import * as metadata from './metadata'

export default {
  ...common,
  ...serviceGroups,
  ...services,
  ...cases,
  ...caseServiceLog,
  ...invoices,
  ...metadata
}



// WEBPACK FOOTER //
// ./src/store/getters/index.js